import { frontendURL } from 'dashboard/helper/URLHelper.js';
import BroadcastsIndex from './pages/BroadcastsIndex.vue';

// Disparador de mensagens (Vincto). Gateado por permissao (admin),
// nao por feature flag (o bigint de feature_flags ja estourou).
const meta = {
  permissions: ['administrator'],
  featureModule: 'disparador',
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/broadcasts'),
    name: 'broadcasts_index',
    meta,
    component: BroadcastsIndex,
  },
];
